import { Fragment } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';

const algorithmSummaryData = [
  {
    label: '내 알고리즘',
    totalCount: 2242,
    winCount: 1932,
  },
  {
    label: '전국',
    totalCount: 21948,
    winCount: 6134,
  },
];

const safetyData = [
  {
    label: '내 알고리즘',
    profit: '86%',
    loss: '14%',
  },
  {
    label: '전국',
    profit: '28%',
    loss: '72%',
  },
];

const BarData = [
  {
    label: '시세차익가능성',
    grade: '보통',
    gradeColor: '#27A131',
    values: [
      [
        {
          label: '시세 (기준)',
          value: '100%',
          color: '#484F55',
          height: 126,
        },
        {
          label: '감정가',
          value: '118.2%',
          color: '#D2D8DF',
          height: 156,
        },
        {
          label: '낙찰가',
          value: '89.8%',
          color: '#008AFF',
          height: 93,
        },
        {
          label: '매각가 (차익률)',
          value: '115.6%',
          color: '#F45551',
          height: 152,
        },
      ],
      [
        {
          label: '시세 (기준)',
          value: '100%',
          color: '#484F55',
          height: 120,
        },
        {
          label: '감정가',
          value: '116%',
          color: '#D2D8DF',
          height: 154,
        },
        {
          label: '낙찰가',
          value: '90%',
          color: '#008AFF',
          height: 99,
        },
        {
          label: '매각가 (차익률)',
          value: '106.4%',
          color: '#F45551',
          height: 133,
        },
      ],
    ],

    extras: [
      { label: '낙찰가 평균', left: '2.19억원', right: '2.27억원' },
      { label: '매각가 평균', left: '2.53억원', right: '2.42억원' },
    ],
  },
  {
    label: '수익성',
    grade: '보통',
    gradeColor: '#27A131',
    values: [
      [
        {
          label: '실제 투자금 대비\n매각수익률',
          value: '17.0%',
          color: '#008AFF',
          height: 156,
        },
        {
          label: '전체 투자금 대비\n매각수익률',
          value: '8.8%',
          color: '#484F55',
          height: 87,
        },
        {
          label: '낙찰가 대비\n매각수익률',
          value: '9.0%',
          color: '#F45551',
          height: 93,
        },
      ],
      [
        {
          label: '실제 투자금 대비\n매각수익률',
          value: '7.7%',
          color: '#008AFF',
          height: 76,
        },
        {
          label: '전체 투자금 대비\n매각수익률',
          value: '4.0%',
          color: '#484F55',
          height: 51,
        },
        {
          label: '낙찰가 대비\n매각수익률',
          value: '3.9%',
          color: '#F45551',
          height: 48,
        },
      ],
    ],

    extras: [
      { label: '실제 투자금 평균', left: '1.16억원', right: '1.16억원' },
      { label: '전체 투자금 평균', left: '2.25억원', right: '2.27억원' },
      { label: '세후이익 평균', left: '1,975만원', right: '895만원' },
      { label: '낙찰가 평균', left: '2.19억원', right: '2.27억원' },
    ],
  },
];

function DetailAnalysis() {
  return (
    <Container>
      <Section>
        <Header>
          <Title>상세분석</Title>
          <TabWrapper>
            <Tab $active>내 알고리즘</Tab>
            <Tab>전국</Tab>
          </TabWrapper>
        </Header>
        <Body>
          <Content>
            <ContentTitleBox>알고리즘모수</ContentTitleBox>
            <GraphWrapper>
              <PieChart>
                <img
                  src="/assets/images/guide-landing/algo/detail-pie-1.svg"
                  alt="pie chart"
                />
              </PieChart>
              <PieChart>
                <img
                  src="/assets/images/guide-landing/algo/detail-pie-2.svg"
                  alt="pie chart"
                />
              </PieChart>
            </GraphWrapper>
            <DataWrapper>
              {algorithmSummaryData.map((item) => (
                <DataColumnContainer key={item.label}>
                  <DataItem>
                    <LegendColor $bg="#D2D8DF" />
                    <ItemContent>
                      <ItemLabel>전체 경매 건수</ItemLabel>
                      <ItemValue>{item.totalCount.toLocaleString()}</ItemValue>
                    </ItemContent>
                  </DataItem>
                  <DataItem>
                    <LegendColor $bg="#008AFF" />
                    <ItemContent>
                      <ItemLabel>수익(Win) 물건 수</ItemLabel>
                      <ItemValue>{item.winCount.toLocaleString()}</ItemValue>
                    </ItemContent>
                  </DataItem>
                </DataColumnContainer>
              ))}
            </DataWrapper>
          </Content>
          <Content>
            <ContentTitleBox>
              안전성
              <GradeLabel $color="#008AFF">매우 높음</GradeLabel>
            </ContentTitleBox>
            <DataWrapper>
              {safetyData.map((item) => (
                <DataColumnContainer key={item.label}>
                  <DataItem>
                    <LegendColor $bg="#D2D8DF" />
                    <ItemContent>
                      <ItemLabel>수익 가능성</ItemLabel>
                      <ItemValue>{item.profit}</ItemValue>
                    </ItemContent>
                  </DataItem>
                  <DataItem>
                    <LegendColor $bg="#008AFF" />
                    <ItemContent>
                      <ItemLabel>손실 가능성</ItemLabel>
                      <ItemValue>{item.loss}</ItemValue>
                    </ItemContent>
                  </DataItem>
                </DataColumnContainer>
              ))}
            </DataWrapper>
          </Content>
        </Body>
      </Section>

      {BarData.map((section) => (
        <Section key={section.label}>
          <Header>
            <Title>상세분석</Title>
            <TabWrapper>
              <Tab $active>내 알고리즘</Tab>
              <Tab>전국</Tab>
            </TabWrapper>
          </Header>
          <Content>
            <ContentTitleBox>
              {section.label}
              <GradeLabel $color={section.gradeColor}>
                {section.grade}
              </GradeLabel>
            </ContentTitleBox>
            <GraphWrapper>
              {section.values.map((value, idx) => (
                <BarChart key={idx}>
                  {value.map((item) => (
                    <Bar
                      key={item.label}
                      $height={item.height}
                      $color={item.color}
                    />
                  ))}
                </BarChart>
              ))}
            </GraphWrapper>
            <DataWrapper>
              {section.values.map((value, idx) => (
                <DataColumnContainer key={idx}>
                  {value.map((item) => (
                    <DataItem key={item.label}>
                      <LegendColor $bg={item.color} />
                      <ItemContent>
                        <ItemLabel>{item.label}</ItemLabel>
                        <ItemValue>{item.value}</ItemValue>
                      </ItemContent>
                    </DataItem>
                  ))}
                </DataColumnContainer>
              ))}
            </DataWrapper>
            <ExtraWrapper>
              <ExtraTitle>보조지표</ExtraTitle>
              <ExtraDataContainer>
                {section.extras.map((item) => (
                  <Fragment key={item.label}>
                    <ItemContent>
                      <ExtraLabel>{item.label}</ExtraLabel>
                      <ExtraValue>{item.left}</ExtraValue>
                    </ItemContent>
                    <ItemContent>
                      <ExtraLabel>{item.label}</ExtraLabel>
                      <ExtraValue>{item.right}</ExtraValue>
                    </ItemContent>
                  </Fragment>
                ))}
              </ExtraDataContainer>
            </ExtraWrapper>
          </Content>
        </Section>
      ))}
    </Container>
  );
}

export default DetailAnalysis;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const Section = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const TabWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
`;

const Tab = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 8px 0;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-bottom: 2px solid;
  border-color: ${({ $active }) => ($active ? '#008AFF' : '#E1E2E4')};

  color: ${({ $active }) => ($active ? '#008AFF' : '#616161')};
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  align-self: stretch;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const ContentTitleBox = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 8px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-bottom: 1px solid #e1e2e4;

  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const GradeLabel = styled.div<{ $color?: string }>`
  color: ${({ $color }) => $color};
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const GraphWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;

const PieChart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
`;

const DataWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
`;

const DataColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  flex: 1 0 0;
`;

const DataItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;
const LegendColor = styled.span<{ $bg: string }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: ${({ $bg }) => $bg};
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
`;

const ItemLabel = styled.div`
  color: #616161;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
  width: 100px;
`;

const ItemValue = styled.div`
  align-self: stretch;
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const BarChart = styled.div`
  display: flex;
  flex-direction: row;
  height: 156px;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;
  flex: 1 0 0;
`;

const Bar = styled.div<{ $height: number; $color: string }>`
  width: 32px;
  height: ${({ $height }) => `${$height}px`};
  min-height: 48px;
  max-height: 156px;
  border-radius: 8px 8px 0 0;
  background: ${({ $color }) => $color};
`;

const ExtraWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  background: #f7f8fc;
`;

// ContentTitleBox
const ExtraTitle = styled(ContentTitleBox)`
  font-weight: 500;
`;

const ExtraDataContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 0;
  align-items: center;
  align-self: stretch;
  justify-items: center;
`;

const ExtraLabel = styled(ItemLabel)`
  text-align: center;
`;

const ExtraValue = styled(ItemValue)`
  align-self: stretch;
  text-align: center;
`;
